const Ls9CasaIgiene = () => {
    return (
        <div className="container-fluid bg--main ps-0 ps-sm-0 ps-md-0 ps-lg-3">
            <div className="row d-flex p-0">
                <div className="col-sm-12 col-md-12 col-lg-7 col-xl-7">
                    <h1 className='titulo--lesson--color--1'>Llegada del <span className='titulo--lesson--color--2'>beb&eacute; a casa</span></h1>

                    <h1 className="text--subtitulo p-4">Cuidados especiales de los beb&eacute;s prematuros</h1>

                    <div className='container'>
                        <div className='container py-3'>
                            <div className='row d-flex align-items-center'>
                                <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                    <img src="./img/Ls9Higiene.png" className='ps-lg-3' />
                                </div>
                                <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                    <p className='texto--parrafo ps-lg-4 ps-xl-4'><span className="texto--span">Higiene:</span> se debe cambiar el pa&ntilde;al cada 3 o 4 horas aunque no lo haya ensuciado.</p>
                                </div>
                            </div>
                        </div>

                        <div className='container py-3'>
                            <div className='row d-flex align-items-center'>
                                <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                    <img src="./img/Ls9AmbienteAdecuado.png" className='ps-lg-3' />
                                </div>
                                <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                    <p className='texto--parrafo ps-lg-4 ps-xl-4'><span className="texto--span">Ambiente adecuado:</span> el prematuro dispone de menor cantidad de grasa corporal. Por eso, se debe emplear ropa adecuada para ayudarle a regular su temperatura. <br /><br />Su habitaci&oacute;n debe estar entre 21 ºC y 24 ºC. Prefiera el uso de calentadores a base de aceite, pues estos no resecan el aire. <br /><br />El m&eacute;todo canguro es otra manera de mantener la temperatura adecuada para el beb&eacute;.</p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className='container p-4'>
                        <p className='texto--link'>
                            Adaptado de: <a className='texto--link' target='_blank' href='https://www.healthychildren.org/English/ages-stages/baby/preemie/Pages/Caring-For-A-Premature-Baby.aspx'> https://www.healthychildren.org/English/ages-stages/baby/preemie/Pages/Caring-For-A-Premature-Baby.aspx</a></p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Ls9CasaIgiene;